import { VodafoneRoutes, VodafoneHashRoutes } from "./Clients/vodafone/Routes";

export const RoutesMapper: Record<string, any> = {
  vodafone: VodafoneRoutes
};

export const HashRoutesMapper = {
  vodafone: VodafoneHashRoutes
};
